if (!customElements.get('track-order-widget')) {
  class TrackOrderWidget extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.form = this.querySelector('[data-track-form]');
      this.input = this.querySelector('[data-track-input]');
      this.error = this.querySelector('[data-track-error]');
      this.result = this.querySelector('[data-track-result]');
      this.abortController = new AbortController();

      this.form?.addEventListener('submit', (event) => this.handleSubmit(event), {
        signal: this.abortController.signal,
      });

      if (this.dataset.autoLookup === 'true') {
        this.trackFromUrl();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.initialized = false;
    }

    handleSubmit(event) {
      event.preventDefault();
      this.track(this.input?.value || '');
    }

    trackFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const trackingNumber = params.get('tracking_number') || params.get('nums') || params.get('track');

      if (!trackingNumber || !this.input) return;

      this.input.value = trackingNumber;
      window.setTimeout(() => this.track(trackingNumber), 250);
    }

    track(value) {
      const trackingNumber = value.trim();

      if (!trackingNumber) {
        this.showError(this.error?.dataset.message || 'Please enter your tracking number.');
        this.input?.focus();
        return;
      }

      if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
        this.showError('Tracking is loading. Please try again in a moment.');
        return;
      }

      this.showError('');

      window.YQV5.trackSingle({
        YQ_ContainerId: this.result.id,
        YQ_Height: Number(this.dataset.height) || 560,
        YQ_Fc: '0',
        YQ_Lang: this.dataset.lang || 'en',
        YQ_Num: trackingNumber,
      });

      this.result.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    showError(message) {
      if (!this.error) return;

      this.error.textContent = message;
      this.error.hidden = !message;
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
  }

  customElements.define('track-order-widget', TrackOrderWidget);
}
